/* eslint-disable sonarjs/cognitive-complexity */

import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import imageHero from '../../assets/hero-urbano.png';
import imageUnctad from '../../assets/logo-unctad.png';
import CommonButton from '../../components/common-button/common-button';
import { Footer } from '../../components/footer/footer';
import HeaderWithoutAuth from '../../components/header-without-auth/header-without-auth';

import { useInterview } from '../../hooks/useInterview';
import {
  Content,
  ContentButton,
  ContentDescription,
  ContentHero,
  ContentTitle,
  Description,
  GradientContainer,
  Title,
  Wrapper,
} from './home-page-style';

export const HomePage = () => {
  const { navigateTo } = Sebrae.useSebraeRouter();
  const { isAuthenticated, login } = Sebrae.useAuth();
  const { interview } = useInterview()



  React.useEffect(() => {
    if (isAuthenticated) {
      return navigateTo('/candidato')
    }
  }, [navigateTo, interview, isAuthenticated]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'space-between',
      }}
    >
      <HeaderWithoutAuth />
      <GradientContainer
        primary={'#215DF4'}
        secondary={'#699FFF'}
        tertiary={'#C5EAFF'}
      >
        <Wrapper>
          <Content>
            <ContentTitle>
              <Title>
                Você é o seu
                <br />
                maior negócio.
              </Title>
              <img src={imageUnctad} alt="imageUnctad" />
            </ContentTitle>
            <ContentDescription>
              <Description>
                O Empretec é o principal programa de formação de empreendedores do mundo, um seminário intensivo criado pela Organização das Nações Unidas (ONU), promovido em 40 países e exclusivo do Sebrae no Brasil.
              </Description>
              <Description>
                Empreender é acreditar no seu potencial!< br />
                Ser um Empreteco é dar o primeiro passo para uma jornada de sucesso e encontrar o empreendedor que está dentro de você.
              </Description>
              <Description>
                Caso já tenha entrado em contato com o sebrae do seu estado e tenha uma entrevista criada, por favor realize o login para iniciar o preenchimento de sua entrevista ou questionário de seleção.
              </Description>
            </ContentDescription>
            <ContentButton>
              <CommonButton
                variant="primary"
                isBold={true}
                backgroundColor="#0000C7"
                onClick={() => login()}
              >
                Realizar login
              </CommonButton>
            </ContentButton>
          </Content>
          <ContentHero>
            <img src={imageHero} alt="hero" />
          </ContentHero>
        </Wrapper>
      </GradientContainer>
      <Footer />
    </div>
  );
};
